/**
 * fiscalData.js
 * Catálogo Fiscal Oficial do Brasil:
 * - Itens da Lei Complementar 116/2003
 * - Códigos da NBS (Nomenclatura Brasileira de Serviços)
 * - Tabela de Atividades Municipais / Tributação Nacional Integrada
 * - Tabela de Situação Tributária do PIS/COFINS (CST)
 * - Regimes de Tributação do Prestador (Simples Nacional e Regimes Especiais)
 */

// 1. REGIMES PERANTE O SIMPLES NACIONAL (Padrão Oficial SEFIN Nacional / SPED)
export const SIMPLES_NACIONAL_OPTIONS = [
  { value: '1', label: '1 - Não Optante - Tributação Normal' },
  { value: '2', label: '2 - Optante - Microempreendedor Individual (MEI)' },
  { value: '3', label: '3 - Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)' },
  { value: '4', label: '4 - Optante Pendente' }
];

// 2. REGIME DE APURAÇÃO DO SIMPLES
export const REGIME_APURACAO_SIMPLES_OPTIONS = [
  { value: '1', label: '1 - Regime de apuração dos tributos federais e municipais pelo Simples Nacional' },
  { value: '2', label: '2 - Regime de apuração dos tributos federais pelo Simples Nacional e ISS pelo Município (estimativa/fixo)' }
];

// 3. REGIMES ESPECIAIS DE TRIBUTAÇÃO
export const REGIME_ESPECIAL_TRIBUTACAO_OPTIONS = [
  { value: '0', label: '0 - Nenhum / Tributação Normal' },
  { value: '1', label: '1 - Ato Cooperado (Cooperativa)' },
  { value: '2', label: '2 - Estimativa' },
  { value: '3', label: '3 - Microempresa Municipal' },
  { value: '4', label: '4 - Notário ou Registrador' },
  { value: '5', label: '5 - Profissional Autônomo' },
  { value: '6', label: '6 - Sociedade de Profissionais (Uniprofissional)' }
];

// 4. SITUAÇÃO TRIBUTÁRIA DO PIS / COFINS (CST) - Conforme tabela da Receita Federal
export const CST_PIS_COFINS_OPTIONS = [
  { value: '00', label: '00 - Nenhum' },
  { value: '01', label: '01 - Operação Tributável com Alíquota Básica' },
  { value: '02', label: '02 - Operação Tributável com Alíquota Diferenciada' },
  { value: '03', label: '03 - Operação Tributável com Alíquota por Unidade de Medida de Produto' },
  { value: '04', label: '04 - Operação Tributável monofásica - Revenda a Alíquota Zero' },
  { value: '05', label: '05 - Operação Tributável por Substituição Tributária' },
  { value: '06', label: '06 - Operação Tributável a Alíquota Zero' },
  { value: '07', label: '07 - Operação Isenta da Contribuição' },
  { value: '08', label: '08 - Operação sem Incidência da Contribuição' },
  { value: '09', label: '09 - Operação com Suspensão da Contribuição' },
  { value: '49', label: '49 - Outras Operações de Saída' },
  { value: '50', label: '50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno' },
  { value: '51', label: '51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno' },
  { value: '52', label: '52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação' },
  { value: '53', label: '53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno' },
  { value: '54', label: '54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação' },
  { value: '55', label: '55 - Operação com Direito a Crédito - Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação' },
  { value: '56', label: '56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação' },
  { value: '99', label: '99 - Outras Operações' }
];

// 5. ATIVIDADES MUNICIPAIS, TRIBUTAÇÃO NACIONAL E NBS INTEGRADOS
// Permite que a seleção da Atividade Municipal preencha automaticamente Item LC 116, Tributação Nacional e NBS
export const ATIVIDADES_SERVICOS = [
  // --- GRUPO 1: SERVIÇOS DE INFORMÁTICA E CONGÊNERES ---
  {
    codigoAtividadeMunicipal: '101',
    itemLc116: '01.01',
    tributacaoNacional: '01.01.01',
    codigoNbs: '1.0101.11.00',
    cnaes: ['6201501', '6202300'],
    descricao: 'Análise e desenvolvimento de sistemas.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '102',
    itemLc116: '01.02',
    tributacaoNacional: '01.02.01',
    codigoNbs: '1.0102.10.00',
    cnaes: ['6201501', '6201502'],
    descricao: 'Programação de computadores.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '103',
    itemLc116: '01.03',
    tributacaoNacional: '01.03.01',
    codigoNbs: '1.0103.11.00',
    cnaes: ['6311900', '6319400'],
    descricao: 'Processamento, armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '104',
    itemLc116: '01.04',
    tributacaoNacional: '01.04.01',
    codigoNbs: '1.0104.10.00',
    cnaes: ['6203100', '6201501'],
    descricao: 'Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '105',
    itemLc116: '01.05',
    tributacaoNacional: '01.05.01',
    codigoNbs: '1.0105.10.00',
    cnaes: ['6202300', '6203100', '6463800'],
    descricao: 'Licenciamento ou cessão de direito de uso de programas de computação.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '106',
    itemLc116: '01.06',
    tributacaoNacional: '01.06.01',
    codigoNbs: '1.0106.10.00',
    cnaes: ['6204000'],
    descricao: 'Assessoria e consultoria em informática.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '107',
    itemLc116: '01.07',
    tributacaoNacional: '01.07.01',
    codigoNbs: '1.0107.10.00',
    cnaes: ['6209100', '9511800'],
    descricao: 'Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '108',
    itemLc116: '01.08',
    tributacaoNacional: '01.08.01',
    codigoNbs: '1.0108.10.00',
    cnaes: ['6201502', '6319400'],
    descricao: 'Planejamento, confecção, manutenção e atualização de páginas eletrônicas.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '109',
    itemLc116: '01.09',
    tributacaoNacional: '01.09.01',
    codigoNbs: '1.0109.10.00',
    cnaes: ['6319400', '7319004'],
    descricao: 'Disponibilização, sem cessão definitiva, de conteúdos de áudio, vídeo, imagem e texto por meio da internet.',
    aliquotaIssSugerida: 2.0
  },

  // --- GRUPO 7: SERVIÇOS RELATIVOS A ENGENHARIA, ARQUITETURA E CONSTRUÇÃO CIVIL ---
  {
    codigoAtividadeMunicipal: '701',
    itemLc116: '07.01',
    tributacaoNacional: '07.01.01',
    codigoNbs: '1.0701.10.00',
    cnaes: ['7112000', '7111100'],
    descricao: 'Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres.',
    aliquotaIssSugerida: 5.0
  },
  {
    codigoAtividadeMunicipal: '702',
    itemLc116: '07.02',
    tributacaoNacional: '07.02.01',
    codigoNbs: '1.0702.10.00',
    cnaes: ['4120400', '4211101', '4299501'],
    descricao: 'Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes.',
    aliquotaIssSugerida: 5.0
  },
  {
    codigoAtividadeMunicipal: '703',
    itemLc116: '07.03',
    tributacaoNacional: '07.03.01',
    codigoNbs: '1.0703.10.00',
    cnaes: ['7112000'],
    descricao: 'Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia.',
    aliquotaIssSugerida: 5.0
  },
  {
    codigoAtividadeMunicipal: '706',
    itemLc116: '07.06',
    tributacaoNacional: '07.06.01',
    codigoNbs: '1.0706.10.00',
    cnaes: ['4399103'],
    descricao: 'Colocação e instalação de tapetes, carpetes, assoalhos, cortinas, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres.',
    aliquotaIssSugerida: 3.0
  },

  // --- GRUPO 10: SERVIÇOS DE INTERMEDIAÇÃO E AGENCIAMENTO ---
  {
    codigoAtividadeMunicipal: '1001',
    itemLc116: '10.01',
    tributacaoNacional: '10.01.01',
    codigoNbs: '1.1001.10.00',
    cnaes: ['7312200'],
    descricao: 'Agenciamento, corretagem ou intermediação de câmbio, de seguros, de títulos ou valores mobiliários.',
    aliquotaIssSugerida: 5.0
  },
  {
    codigoAtividadeMunicipal: '1005',
    itemLc116: '10.05',
    tributacaoNacional: '10.05.01',
    codigoNbs: '1.1005.10.00',
    cnaes: ['7490104', '7319002'],
    descricao: 'Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens.',
    aliquotaIssSugerida: 3.0
  },

  // --- GRUPO 14: SERVIÇOS RELATIVOS A BENS DE TERCEIROS (MANUTENÇÃO / REPAROS) ---
  {
    codigoAtividadeMunicipal: '1401',
    itemLc116: '14.01',
    tributacaoNacional: '14.01.01',
    codigoNbs: '1.1401.10.00',
    cnaes: ['4520001', '3314710', '9529199'],
    descricao: 'Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto.',
    aliquotaIssSugerida: 3.0
  },
  {
    codigoAtividadeMunicipal: '1402',
    itemLc116: '14.02',
    tributacaoNacional: '14.02.01',
    codigoNbs: '1.1402.10.00',
    cnaes: ['3319800'],
    descricao: 'Assistência técnica.',
    aliquotaIssSugerida: 2.0
  },

  // --- GRUPO 17: SERVIÇOS DE APOIO TÉCNICO, ADMINISTRATIVO, JURÍDICO, CONTÁBIL, COMERCIAL ---
  {
    codigoAtividadeMunicipal: '1701',
    itemLc116: '17.01',
    tributacaoNacional: '17.01.01',
    codigoNbs: '1.1701.10.00',
    cnaes: ['7020400'],
    descricao: 'Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista.',
    aliquotaIssSugerida: 3.0
  },
  {
    codigoAtividadeMunicipal: '1702',
    itemLc116: '17.02',
    tributacaoNacional: '17.02.01',
    codigoNbs: '1.1702.10.00',
    cnaes: ['8219999'],
    descricao: 'Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e suporte administrativo.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '1706',
    itemLc116: '17.06',
    tributacaoNacional: '17.06.01',
    codigoNbs: '1.1706.10.00',
    cnaes: ['7319003', '7311400'],
    descricao: 'Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade.',
    aliquotaIssSugerida: 3.0
  },
  {
    codigoAtividadeMunicipal: '1714',
    itemLc116: '17.14',
    tributacaoNacional: '17.14.01',
    codigoNbs: '1.1714.10.00',
    cnaes: ['6911701', '6911702'],
    descricao: 'Advocacia.',
    aliquotaIssSugerida: 3.0
  },
  {
    codigoAtividadeMunicipal: '1719',
    itemLc116: '17.19',
    tributacaoNacional: '17.19.01',
    codigoNbs: '1.1719.10.00',
    cnaes: ['6920601', '6920602'],
    descricao: 'Contabilidade, inclusive serviços técnicos e auxiliares.',
    aliquotaIssSugerida: 2.0
  },
  {
    codigoAtividadeMunicipal: '1723',
    itemLc116: '17.23',
    tributacaoNacional: '17.23.01',
    codigoNbs: '1.1723.10.00',
    cnaes: ['8220200'],
    descricao: 'Teleatendimento, telemarketing, centrais de atendimento (call center) e congêneres.',
    aliquotaIssSugerida: 2.0
  }
];

/**
 * Função utilitária para buscar atividades compatíveis com um determinado CNAE
 */
export function filtrarAtividadesPorCnae(cnae) {
  if (!cnae) return ATIVIDADES_SERVICOS;
  const list = Array.isArray(cnae) ? cnae : [cnae];
  const limpos = list.map(c => String(c).replace(/\D/g, '')).filter(Boolean);
  if (limpos.length === 0) return ATIVIDADES_SERVICOS;
  return ATIVIDADES_SERVICOS.filter(item => 
    item.cnaes && item.cnaes.some(c => limpos.some(limpo => limpo.startsWith(c.slice(0, 4)) || c.startsWith(limpo.slice(0, 4))))
  );
}

/**
 * Formata o label da atividade conforme exibido nos sistemas fiscais
 * Ex: "103 - 01.03 - Processamento, armazenamento ou hospedagem de dados..."
 */
export function formatarLabelAtividade(item) {
  return `${item.codigoAtividadeMunicipal} - ${item.itemLc116} - ${item.descricao}`;
}
